import React, { useCallback } from 'react';
import { Button, makeStyles } from '@material-ui/core';

import { RootStoreContext } from '../../context';


const useStyles = makeStyles(() => {
  return {
    tipButton: {
      color: '#fff',
      background: 'linear-gradient(180deg, #de3435, #6b0000)',
      maxWidth: 'fit-content',
      margin: 0,
      border: 'none',
      borderRadius: 25,
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 5,
      paddingBottom: 5,
      fontSize: '16px',
      '&:hover': { backgroundColor: '#8a1816' },
    },
  };
});


function TipButton(props) {
  const { anchor, showTipButton } = props;
  const classes = useStyles();
  const context = React.useContext(RootStoreContext);
  const { tippingStore } = context;

  const onTipButtonClick = useCallback(() => {
    tippingStore.setIsLiveShowTip(false);
    tippingStore.setTippingModal(anchor);
  }, [anchor, tippingStore]);

  if (!showTipButton) {
    return null;
  }

  return (
    <Button className={classes.tipButton} onClick={onTipButtonClick}>
      Tip {anchor?.name}
    </Button>
  );
}

export default React.memo(TipButton);
